import AddCommentIcon from "@mui/icons-material/AddComment";
import { Button, Tooltip } from "@avenue-8/sidekick-ui";
import { CollapsedNewChatButton } from "../styles";

type Props = {
  onClick: () => void;
  disabled?: boolean;
  collapsed?: boolean;
};

export const NewChatButton = (props: Props) => {
  const { onClick, disabled = false, collapsed = false } = props;

  if (collapsed) {
    return (
      <Tooltip title="New chat" placement="right">
        <span>
          <CollapsedNewChatButton
            onClick={onClick}
            disabled={disabled}
            aria-label="New chat"
          >
            <AddCommentIcon fontSize="small" />
          </CollapsedNewChatButton>
        </span>
      </Tooltip>
    );
  }

  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      id="sidekick-sidebar-create-new-chat"
      startIcon={<AddCommentIcon />}
      fullWidth
    >
      NEW CHAT
    </Button>
  );
};
